export default __webpack_public_path__ + "d2b54ca08f3d2df5704e2e82da70e2ee.svg";